/**
 * Static municipality name-to-ID mapping
 * Used as fallback when Supabase queries fail
 * Generated from database on 2025-12-12
 */

export const MUNICIPALITY_IDS: Record<string, string> = {
  'Ahumada': '5f61abee-0850-4e70-adb6-4a1486a52726',
  'Aldama': '65b00d48-db46-4764-b792-43781bd0a520',
  'Allende': 'aba06b12-3775-42ec-9af0-aef63f65ba66',
  'Aquiles Serdán': '4402559e-93d0-4ddf-bf86-e1b5ff873aee',
  'Ascensión': 'bed6ca8f-0588-4f5b-b0e3-10fe4dcedeec',
  'Bachíniva': '81b8edb4-a73c-4b83-8df5-367bd9c2f581',
  'Balleza': '82fa1307-1fc5-42a2-8cfe-cc7418564485',
  'Batopilas de Manuel Gómez Morín': '057d3e78-9d4b-4e0b-90a0-cfb4c1794842',
  'Bocoyna': '293147b0-870c-448e-88be-616367f44769',
  'Buenaventura': 'ea9fa42b-0e29-40a8-8f79-8911547fe77c',
  'Camargo': '1b33b9fa-1e70-4634-a200-2277de5573bc',
  'Carichí': '632d3c77-aa6f-4d16-9997-9c1e245f6eca',
  'Casas Grandes': 'bd3a7fd1-ac41-42c2-b0d5-00bc9d5d151c',
  'Chihuahua': '4a731535-4f39-4383-940f-4fc0d82a3b72',
  'Chínipas': '5fa27e6a-7788-42e3-8b32-88506b5f0201',
  'Coronado': '23927453-7dcc-4953-af27-39d134cb69a6',
  'Coyame del Sotol': '291178d2-3fb4-48cb-87af-f08d8e8b4bde',
  'Cuauhtémoc': 'd594a8b5-f1e8-4691-8939-39c103f5592f',
  'Cusihuiriachi': 'da4dc373-a8a8-4076-86db-24c4e0c9b06d',
  'Delicias': 'fe0f9582-47bb-4f0e-b68c-98e270b6917c',
  'Dr. Belisario Domínguez': 'cccaac6e-b7e6-45f5-be72-f87b63f82b5f',
  'El Tule': '0aa93fca-41cb-46d5-aab3-d834649a36ad',
  'Galeana': '173017dc-f24a-4444-9c6f-ef58b6f9e130',
  'Gómez Farías': '1f5fbfd8-e48c-4f3d-b614-98c2163ede99',
  'Gran Morelos': '6775f06a-2eaa-4007-91a3-48fa67530833',
  'Guachochi': '5b62d9df-745b-4acc-a491-f6a8c8bbbc7f',
  'Guadalupe': '3321d238-9ca2-47ac-960a-8bc15d174bd0',
  'Guadalupe y Calvo': '47bf76c1-5b8f-4c35-9f91-6f9728c87cfe',
  'Guazapares': '6cfb4a31-7bd1-4baf-a4b7-34eddd3f7165',
  'Guerrero': '304d6bde-3a67-40b7-a774-703b0ec1ba30',
  'Hidalgo del Parral': 'cbbf99aa-4b2e-4bd5-87be-0149ad5b243e',
  'Huejotitán': '0dd4e46f-37ad-4231-bcbf-abbad9e78ab8',
  'Ignacio Zaragoza': 'e6e2cf0a-d317-4ee9-ac20-52c917b219ae',
  'Janos': 'f27b9ff4-d0be-4be6-8f69-b295dbe8e09b',
  'Jiménez': '69707972-bc1c-459f-a17d-54a64d2ab87f',
  'Juárez': '59169446-e180-4102-addf-51d2dc95f7f3',
  'Julimes': '1176a431-dc99-4a47-97dc-ecbff1457a62',
  'La Cruz': 'b3fc67d7-7425-42a1-a6cf-f3c3585619a8',
  'López': 'f072dc0f-8d5f-4204-a132-553a6066dbf0',
  'Madera': '98682801-a097-483a-878b-ba168e59c911',
  'Maguarichi': 'a8b67b4a-0ffe-4b9b-8d21-0bd14a075a3e',
  'Manuel Benavides': '4b605bf3-5b8e-4b4f-aa4e-9aca31f469d4',
  'Manuel Doblado': '450270b8-fbc1-4695-aa50-54e6a7f930b4',
  'Matachí': '47265e15-fbaa-4442-a5b0-4b4ed142295f',
  'Matamoros': 'bf5357fc-96fd-420f-ad44-3f07e2220c13',
  'Meoqui': 'fbf385f2-abec-4fa2-aa93-5c7802f4eef5',
  'Morelos': 'b1ba4d0b-75fa-4bad-a516-1c43943dbb2e',
  'Moris': '36f7e731-8fe5-4f74-a64d-14e03dd717ad',
  'Namiquipa': '5b25feae-1473-48e8-b0e9-5998a58b6e68',
  'Nonoava': '3328fb41-896e-42d3-bdbe-1ca9f0b61620',
  'Nuevo Casas Grandes': '9fc87d90-769a-46ad-ae72-8132fdcab237',
  'Ocampo': '26b70b23-c251-4c20-81e9-6df0c96970ca',
  'Ojinaga': '3cb77049-9f12-4be2-a444-b941aae2cf69',
  'Praxedis G. Guerrero': '97c618ae-b48c-4580-acd5-84445cbb8bbb',
  'Riva Palacio': '88b7bf23-bcdb-408b-8605-9309a5b7b4f3',
  'Rosales': '942a3e78-3f14-4239-972e-8ee5f77657d4',
  'Rosario': '626c4094-dc3a-41ed-bed9-2811492ee45c',
  'San Francisco de Borja': '9c31b3c6-6348-48ab-ab08-fbad46fb7cd9',
  'San Francisco de Conchos': '00705ad2-4eaf-48d5-88ab-591f89efd12a',
  'San Francisco del Oro': '5559bddc-1c2f-4d61-867f-db5f6b91f107',
  'Santa Bárbara': '028ca52b-3801-4924-a857-492d47a64520',
  'Satevó': 'd7ae7e44-435c-4e27-919a-38740f857f38',
  'Saucillo': 'd63e7f34-51f7-4524-a84d-a8f679bf1175',
  'Temósachic': '99582958-cb0b-4143-9710-1fcc0017fe38',
  'Urique': '3c39c945-3be3-4d57-a0d4-1b7dd34b1401',
  'Uruachi': '599a4f32-09b3-4a51-a09f-310949b2fc99',
  'Valle de Zaragoza': 'd8642db3-e909-4f20-900f-67f829d1b55a',
};

/**
 * Get municipality ID by name (static fallback)
 */
export function getMunicipalityIdStatic(name: string): string | null {
  if (!name || name === 'Filtrar por municipio' || name === 'Todos los municipios') {
    return null;
  }
  return MUNICIPALITY_IDS[name] || null;
}











